import React, { useState, useRef } from "react";

import { images } from "../../constants";
import { AppWrap, MotionWrap } from "../../wrapper";
import { client } from "../../client";
import "./Footer.scss";
import { useContext } from "react";
import { ThemeContext } from "../../ThemeContext";
import emailjs from "@emailjs/browser";

const PublicKey = process.env.REACT_APP_PUBLIC_KEY;
const TemplateID = process.env.REACT_APP_TEMPLATE_ID;
const ServiceID = process.env.REACT_APP_SERVICE_ID;
// console.log(PublicKey);
// console.log(TemplateID);
// console.log(ServiceID);

const Footer = () => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    message: "",
  });
  const form = useRef();
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [loading, setLoading] = useState(false);
  const { darkMode } = useContext(ThemeContext);

  const { username, email, message } = formData;

  const handleChangeInput = (e) => {
    e.preventDefault();
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setLoading(true);

    const contact = {
      _type: "contact",
      // name: formData.username,  // as destructered the values above we can also use like below.
      name: username,
      email: email,
      message: message,
    };

    client
      .create(contact)
      .then(() => {
        setLoading(false);
        setIsFormSubmitted(true);
      })
      .catch((err) => console.log(err));

    emailjs.sendForm(ServiceID, TemplateID, form.current, PublicKey).then(
      (result) => {
        console.log(result.text);
      },
      (error) => {
        console.log(error.text);
      }
    );
  };

  return (
    <>
      <h2 className={darkMode === true ? "head-text-true" : "head-text"}>
        Thanks for taking the time to reach out.
        <br /> How can I help you today?
      </h2>

      <div className="app__footer-cards">
        <div className="app__footer-card">
          <img src={images.email} alt="email" />
          <a href="malikfasih08@gmail.com" className="p-text">
            malikfasih08@gmail.com
          </a>
        </div>
        <div className="app__footer-card">
          <img src={images.mobile} alt="phone" />
          <a href="tel:+92-(334)-7776207" className="p-text">
            +92-(334)-7776207
          </a>
        </div>
      </div>
      {!isFormSubmitted ? (
        <form
          className="app__footer-form app__flex"
          action=""
          onSubmit={handleSubmit}
          ref={form}
        >
          <div className="app__flex">
            <input
              className="p-text"
              type="text"
              placeholder="Your Name"
              name="username"
              value={username}
              onChange={handleChangeInput}
              required
            />
          </div>
          <div className="app__flex">
            <input
              className="p-text"
              type="email"
              placeholder="Your Email"
              name="email"
              value={email}
              onChange={handleChangeInput}
              required
            />
          </div>
          <div>
            <textarea
              className="p-text"
              placeholder="Your Message"
              value={message}
              name="message"
              onChange={handleChangeInput}
              required
            />
          </div>
          <button
            type="submit"
            className={darkMode === true ? "button-true" : "button"}
            onSubmit={handleSubmit}
          >
            {!loading ? "Send Message" : "Sending..."}
          </button>
        </form>
      ) : (
        <div>
          <h3 className={darkMode === true ? "head-text-true" : "head-text"}>
            Thank you for getting in touch!
          </h3>
        </div>
      )}
    </>
  );
};

export default AppWrap(
  MotionWrap(Footer, "app__footer"),
  "contact",
  "app__primarybg"
);
